import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-all-data-text-filter',
  templateUrl: './text-filter.component.html',
  styleUrls: ['./text-filter.component.scss'],
  imports: [MatFormField, MatInput, FormsModule],
})
export class AllDataTextFilterComponent implements OnInit {
  @Input() set data(value: string) {
    this.value = value;
  }

  @Input() placeholder!: string;
  @Input() onClear!: Subject<void>;

  @Output() filterChange = new EventEmitter<string>();

  value?: string;

  ngOnInit(): void {
    this.onClear.subscribe(() => {
      this.value = '';
    });
  }

  onFilterChange() {
    this.filterChange.emit(this.value);
  }
}
